/*
 * Chanche: keep keyboard focus out of carousel slides that are hidden from screen readers.
 * Fabric's slideshow marks off-screen slides aria-hidden="true" (assets/slideshow.js) but their
 * links, quick-add buttons and swatches stay tabbable. `inert` would also block the mouse on
 * half-visible peek cards, so only the tab order changes: tabindex="-1" while hidden, restored
 * when the slide comes back into view.
 */
(() => {
  const FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const SLIDES = 'slideshow-slide';

  function sync(slide) {
    const hidden = slide.getAttribute('aria-hidden') === 'true';
    for (const el of slide.querySelectorAll(hidden ? FOCUSABLE : '[data-chanche-tabindex]')) {
      if (hidden) {
        if (el.dataset.chancheTabindex !== undefined) continue;
        el.dataset.chancheTabindex = el.getAttribute('tabindex') ?? '';
        el.setAttribute('tabindex', '-1');
      } else {
        const original = el.dataset.chancheTabindex;
        if (original) el.setAttribute('tabindex', original);
        else el.removeAttribute('tabindex');
        delete el.dataset.chancheTabindex;
      }
    }
  }

  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target instanceof Element && record.target.matches(SLIDES)) {
        sync(record.target);
      } else if (record.type === 'childList') {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(SLIDES)) sync(node);
          node.querySelectorAll?.(SLIDES).forEach(sync);
        }
      }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });

  document.querySelectorAll(SLIDES).forEach(sync);
})();
